import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { request } from '../../config/helpers/axios-instance'
import { toast } from 'react-toastify'
import Modal from '../Modal'

const OrderPackedButton = ({ orderId }) => {
    const [showModal, setShowModal] = useState(false)

    const handleOrderPacked = async () => {
        try {
            const res = await request({
                url: `userOrder/admin/markOrderAsPacked/${orderId}`,
                method: "POST",
            });

            if (res && res.data.success) {
                toast.success("Order marked as packed successfully!")
                setShowModal(false)
            } else {
                toast.warn("Error marking order as packed!")
            }
        } catch (error) {
            toast.warn("Something went wrong!")
        }
    }

    const handleConfirm = () => {
        handleOrderPacked()
    }

    const handleCancel = () => {
        setShowModal(false)
    }

    return (
        <>
            <button
                className="p-2 bg-[#008000] rounded-xl text-[white] text-center text-xl flex-auto cursor-pointer"
                onClick={() => setShowModal(true)}
            >
                Order Packed
            </button>

            {showModal && (
                <Modal title="Confirm Action" onClose={handleCancel}>
                    <div className="py-4">
                        <p className="text-lg mb-6">Are you sure you want to mark the order as packed?</p>
                        <div className="flex justify-end gap-3">
                            <button
                                onClick={handleCancel}
                                className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 transition-colors"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleConfirm}
                                className="px-4 py-2 bg-green-600 text-white-50 rounded hover:bg-green-700 transition-colors"
                            >
                                Confirm
                            </button>
                        </div>
                    </div>
                </Modal>
            )}
        </>
    )
}

OrderPackedButton.propTypes = {
    orderId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}

export default OrderPackedButton